import { all } from 'redux-saga/effects';

import deleteFavoriteSagas from './deleteFavorite';
import getMyFavoritesSagas from './getMyFavorites';

export default function* rootSaga() {
  yield all([getMyFavoritesSagas(), deleteFavoriteSagas()]);
}
